export default __webpack_public_path__ + "static/media/1.12d812d9.png";